import React, { useEffect, useState, useRef } from "react";
import mapboxgl from "mapbox-gl";
mapboxgl.accessToken = "pk.eyJ1IjoiZ2V0bXVsbGVyZWQiLCJhIjoiY2tkbHd1MnYxMTJ4aDJxczhlaXo3dzB3MyJ9.PGg5pphc3KucWpAsvBr8Ag";
const coordinates = require("../data/coordinates").coordinates;

export const Map = ({ stateC, stateR, stateD, tested, vaccinated, stateinfo }) => {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [lat, setLat] = useState(22.6);
  const [lng, setLng] = useState(80.43);
  const [zoom, setZoom] = useState(3.65);

  useEffect(() => {
    if (map.current) return;
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/light-v10",
      center: [lng, lat],
      zoom: zoom,
      interactive: false,
    });
    var i = 0;
    coordinates.forEach((el) => {
      new mapboxgl.Marker({ scale: 1 })
        .setLngLat([el[0], el[1]])
        .setPopup(
          new mapboxgl.Popup({ offset: 25 }) // add popups
            .setHTML(
              "<h3>" +
                stateinfo[i] +
                "</h3><p>Confirmed:" +
                stateC[i] +
                "<br />Deceased:" +
                stateD[i] +
                "<br/> Recovered:" +
                stateR[i] +
                "<br/>Tested:" +
                tested[i] +
                "<br/>Vaccinated:" +
                vaccinated[i] +
                "</p>"
            )
        )
        .addTo(map.current);
      i++;
    });
  }, []);

  return (
    <div>
      <div ref={mapContainer} className="map-container" />
    </div>
  );
};
export default Map;
